import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { mapState } from "vuex";
import rules from "@/utils/pattern.js";
import { onInputRange } from "@/utils/util.js";
import { getFirstLetter } from "@/utils/index.js";
import { separateNames } from "@/utils/separate-names.js";
import CountryCode from "@/components/countryCode/countryCode.vue";
import ProChiose from "@/components/pro-common/pro-chiose-modal/pro-chiose.vue";
import ProEncInput from "@/components/pro-common/pro-enc/pro-enc-input.vue";
// import PasswordInput from "@/components/Common/passwordInput.vue";

export default {
  name: "member-add-tab-base",
  components: {
    ProEncInput,
    ProChiose,
    CountryCode
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false;
      }
    },
    isDetail: {
      type: Boolean,
      default() {
        return false;
      }
    },
    edit: {
      type: Boolean,
      default() {
        return false;
      }
    },
    member: {
      type: Object,
      default() {
        return {};
      }
    },
    row: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
    // labelWidth() {
    //   return i18n.locale === "en-US" ? 120 : 91;
    // },
  },
  data() {
    return {
      departmemt: {
        visible: false,
        checkedList: []
      },
      position: {
        visible: false,
        checkedList: []
      },
      apps: {
        visible: false,
        checkedList: []
      },
      form: {
        userName: "",
        userCode: "",
        userSurname: "",
        userGivenName: "",
        userNickname: "",
        userNumber: "",
        userMobile: "",
        mobileAreaCode: "+86",
        userEmail: "",
        departmentIds: [],
        positionIds: [],
        appIds: [],
        interfaceOnly: "F",
        password: "",
        status: ""
      },
      myRules: {
        // 成员姓名
        userName: [{
          required: true,
          // lg: 姓名不能为空
          message: $t("3nw9m26", "姓名不能为空")
        }, rules.userName],
        userNickname: [rules.nickName],
        userSurname: [{
          required: true,
          // lg: 姓氏不能为空
          message: $t("qi3qgc6", "姓氏不能为空")
        }, rules.name],
        userGivenName: [{
          required: true,
          // lg: 名字不能为空
          message: $t("scok5i6", "名字不能为空")
        }, rules.name],
        userCode: [{
          // 用户代码输入框始终展示，但只有 GIG 单位才要求必填。
          required: Boolean(this.$store.state.user.gig),
          message: $t("qsi8t8", "用户代码不能为空")
        }, rules.userCode],
        userEmail: [{
          validator: (rule, value, callback) => {
            let reg = rules.userEmail.pattern;
            if (typeof value != "object") {
              if (value && !reg.test(value)) {
                callback(rules.userEmail.message);
              } else if (value.length > 50) {
                // lg: 邮箱长度不能超过50字
                callback($t("vshsm8b", "邮箱长度不能超过50字"));
              } else {
                callback();
              }
            } else {
              callback();
            }
          },
          trigger: "blur, change"
        }],
        userNumber: [rules.userNumber]
      }
      // 暂时注释，后续产品确定启用时间
      // columns: [
      // {
      //   // lg: 接口用户
      //   title: "接口用户",
      //   key: "interfaceOnly",
      //   formLineNum: 2,
      //   showForm: () => {
      //     return (
      //       this.$store.state.user.gig &&
      //       !this.form.userEmail &&
      //       !this.form.userMobile
      //     );
      //   },
      //   renderForm: () => {
      //     // lg: 接口用户仅用于系统间通信，无法登录iWork
      //     return (
      //       <div>
      //         <div class="flex items-center gap-1">
      //           <i-switch
      //             v-model={this.form.interfaceOnly}
      //             true-value="T"
      //             false-value="F"
      //           ></i-switch>
      //           <span class="flex-1">（接口用户）</span>
      //           {this.form.interfaceOnly === "T" ? (
      //             <PasswordInput
      //               ref="passwordInputRef"
      //               v-model={this.form.password}
      //               label=""
      //               style={{
      //                 width: "300px",
      //                 marginBottom: "0",
      //               }}
      //             />
      //           ) : (
      //             ""
      //           )}
      //         </div>
      //       </div>
      //     );
      //   },
      // },
      // ],
    };
  },
  watch: {
    visible(val) {
      if (!val) {
        this.reset();
        // 容器滚动到最顶部
        this.$refs.memberDetailRef.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    },
    // 外部带入已保存的表单信息
    member(val) {
      // 详情
      if (val.userId) {
        Object.keys(val).forEach(key => {
          if (Object.prototype.hasOwnProperty.call(this.form, key)) {
            this.form[key] = val[key];
          }
        });
        this.form.departmentIds = val.departments.map(v => v.orgId);
        this.form.positionIds = val.positions.map(v => v.tagId);
        this.form.appIds = val.apps.map(v => v.appId);
        this.departmemt.checkedList = val.departments;
        this.position.checkedList = val.positions;
        this.apps.checkedList = val.apps;
      } else {
        // 新增
        if (val.departments) {
          this.form.departmentIds = val.departments.map(v => v.orgId);
          this.departmemt.checkedList = val.departments;
        }
      }
    }
  },
  methods: {
    handleProChioseChange(list, formKey, itemKey) {
      this.$set(this.form, formKey, list.map(v => v[itemKey]));
      console.log(this.form);
    },
    handleUserCodeChange(val) {
      this.form.userCode = val.replace(/\s/g, "").toUpperCase();
    },
    handleEmailChange() {
      onInputRange(this, this.form, "userEmail", "userJoinInputEmail");
    },
    handleUserNameChange() {
      this.form.userName = this.form.userName.trim();
      let names = separateNames(this.form.userName);
      this.form.userSurname = names[0];
      this.form.userGivenName = names[1];
      this.setUserCode();
    },
    setUserCode() {
      if (this.edit) {
        return;
      }
      let {
        unitCode = ""
      } = this.user.userInfo;
      // 用户代码前缀只允许保留单位编码前 10 位，避免超长 unitCode 直接拼进账号标识。
      const limitedUnitCode = String(unitCode).slice(0, 10);
      let code = getFirstLetter(this.form.userName);
      // console.log(`${unitCode}-${code}`);
      this.form.userCode = code ? `${limitedUnitCode}-${code}` : "";
    },
    handleNameChange() {
      this.form.userName = `${this.form.userSurname}${this.form.userGivenName}`;
      this.setUserCode();
    },
    reset() {
      this.departmemt.visible = false;
      this.departmemt.checkedList = [];
      this.position.visible = false;
      this.position.checkedList = [];
      this.apps.visible = false;
      this.apps.checkedList = [];
      Object.keys(this.form).forEach(key => {
        this.form[key] = "";
      });
      this.form.mobileAreaCode = "+86";
      this.form.departmentIds = [];
      this.form.positionIds = [];
      this.form.appIds = [];
      this.$refs["userForm"].resetFields();
    },
    validate() {
      return new Promise(resolve => {
        let passwordValid = true;
        let passwordInputRef = this.$refs.passwordInputRef;
        if (passwordInputRef && passwordInputRef.validate) {
          passwordValid = passwordInputRef.validate();
        }
        console.log(passwordInputRef);
        resolve({
          validate: this.$refs.userForm.validate,
          form: this.form,
          passwordValid
        });
      });
    }
  }
};